import React from 'react';
import './Trainers.css';

const Trainers: React.FC = () => {
  return (
    <div className="n-page n-trainers">
      <header className="n-page-header">
        <div className="container">
          <span className="n-page-eyebrow">MEET YOUR TRAINER</span>
          <h1>TRAINER</h1>
          <p>トレーナー紹介</p>
        </div>
      </header>
      <section className="n-page-body">
        <div className="n-page-content n-trainer-profile">
          <figure className="n-trainer-photo">
            <img src="/images/natsumi.png" alt="チーフトレーナー Natsumi" />
            <figcaption>
              <span>CHIEF TRAINER</span>
              <strong>Natsumi</strong>
            </figcaption>
          </figure>
          <div className="n-trainer-bio">
            <span className="n-page-eyebrow">A LITTLE ABOUT ME</span>
            <h2>なつみ</h2>
            <p className="n-trainer-role">チーフトレーナー</p>
            <p>7歳から17歳まで新体操に取り組み、身体づくりに向き合ってきました。自身のダイエット経験から食事の大切さを知り、大学で栄養学を学びました。</p>
            <p>管理栄養士としての知識に加え、ヨガインストラクターの資格を取得。呼吸や正しい身体の動かし方を大切にしながら、トレーニングの楽しさをお伝えします。</p>
            <div className="n-trainer-credentials">
              <span>管理栄養士</span>
              <span>ヨガインストラクター</span>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Trainers;